export const applicationData = {
    // @ts-ignore
    version: process.env.version,
    // @ts-ignore
    backendUrl: process.env.backendUrl,
    // @ts-ignore
    gaMeasurementId: process.env.gaMeasurementId,
    contexts: [
        {
            contextId: 'a24f77d8-3dca-4136-87ec-f31dab970fba',
            code: 'root',
            theme: 'default',
            locales: ['cs', 'en', 'xx'],
            matchers: [],
            gaMeasurementId: null
        },
        {
            contextId: '23e7bfac-15f7-4dde-acbd-b2f8bd3af50d',
            code: 'pld',
            theme: 'pld',
            locales: ['cs'],
            matchers: [
                { exact: 'www.chat-pomoc.cz' },
                { exact: 'localhost:8080' }
            ],
            gaMeasurementId: 'G-T2HY4YSRCP'
        },
        {
            contextId: 'c228fc60-8fa8-46c4-b0f6-ab44bc4a1865',
            code: 'strada',
            theme: 'strada',
            locales: ['cs', 'en', 'bg', 'fr', 'mn', 'ph', 'ro', 'uk', 'ru'],
            matchers: [
                { exact: 'chat.strada.cz' },
                { exact: 'localhost:8081' },
                { exact: 'ancha.vercel.app' }
            ],
            gaMeasurementId: null
        },
        {
            contextId: 'a74f237e-5084-4421-856c-3d8e7dde0e8c',
            code: 'lduo',
            theme: 'lduo',
            locales: ['cs'],
            matchers: [
                { exact: 'chat.linkaduveryuo.cz' },
                { exact: 'localhost:8082' },
                { regex: 'ancha-git-.*-janpachols-projects\.vercel\.app' }
            ],
            gaMeasurementId: null
        }
    ],
};
